import React from 'react'
import { useLocation } from 'react-router-dom'
export const Footer=()=> {
    const location=useLocation();
    const routeName=location.pathname;
  return (
   <>
  <div id="footer" class={`${routeName==="/login"?"app-footer-login":"app-footer"}`}>
  {/* Aletheia Retail Powered by <a href="http://aletheia-ai.tech">Aletheia-AI</a> */}
  Powered By: Aletheia-Ai
  </div>
   </>
  )
}
